const TRUNCATE_AT = 42;

export const truncate = (name: string) =>
  name.length > TRUNCATE_AT ? `${name.slice(0, TRUNCATE_AT)}...` : name;
